const datalayerPublicHelpers = require('../components/datalayer/publicHelpers');

/**
 * Clones tile item sizes to a common sticky wrapper and prepare it for
 * analytics. As the destination container is outside the product tile, we must
 * adapt it for the events that uses the tile for extracting info.
 *
 * @param {Object} params Function params
 * @param {string} params.pid Product ID
 * @param {string} params.productImpressionId The ID of the product impression
 *  (analytics info)
 * @param {jQuery<HTMLDivElement>} params.$destinationContainer The element
 *  where the product sizes will be cloned into
 * @param {jQuery<HTMLDivElement>} params.$productTileSizesInfo Wrapper info
 *  section that contains the different sizes and related info (for instance:
 *  .product-tile__sizes-info)
 * @returns {jQuery<HTMLDivElement>} Cloned info section in the sticky container
 */
function cloneProductTileSizesToStickyWrapper({
    pid,
    productImpressionId,
    $destinationContainer,
    $productTileSizesInfo
}) {
    let $clonedProductSizesInfo = $destinationContainer.find(
        '.product-info__sizes-info[data-pid="' + pid + '"]'
    );

    if ($clonedProductSizesInfo.length < 1) {
        $productTileSizesInfo.clone().appendTo($destinationContainer).addClass('cloned');
        $clonedProductSizesInfo = $destinationContainer.find(
            '.product-info__sizes-info[data-pid="' + pid + '"]'
        );
    }

    // As the cloned sizes are outside the product tile in mobile, we must mark
    // the cloned wrapper as product impression element for analytics purposes
    datalayerPublicHelpers.impressions.markAsProductImpressionElement(
        $clonedProductSizesInfo.get(0),
        productImpressionId
    );

    return $clonedProductSizesInfo;
}

module.exports = cloneProductTileSizesToStickyWrapper;
